
  <template>
    <div :style="containerStyle">
   <!--    <a
        :href="data?.props?.url"
        :style="buttonStyle"
        target="_blank"
      > -->
      <a
      
        :style="buttonStyle"
        target="_blank"
      >
        <span></span>
        <span>{{ data?.props?.text }}</span>
        <span></span>
      </a>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  export default {
    name: 'ButtonBlock',
    props: {
      data: Object,
    },
    computed: {
      ...mapState(['emailData']),
      containerStyle() {
        const style = this.data?.style || {};
        const padding = style.padding || { top: 0, bottom: 0, left: 0, right: 0 };
        const textAlign = style.textAlign || 'left';
        const backgroundColor = style?.backgroundColor || 'transparent';
        return {
          textAlign: textAlign,
          backgroundColor: backgroundColor,
          padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
        };
      },
      buttonStyle() {
        const fontFamilyMapping = {
        BOOK_SANS: 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif',
        ORGANIC_SANS: 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif',
        GEOMETRIC_SANS: 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif',
        HEAVY_SANS: 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif',
        ROUNDED_SANS: 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif',
        MODERN_SERIF: 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif',
        BOOK_SERIF: '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif',
        MONOSPACE: '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace',
        MODERN_SANS: '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
        SIMPLE: 'Arial',
        DEFAULT: 'inherit'
        };
        const style = this.data?.style || {};
        const props = this.data?.props || {};
        const fontSize = style.fontSize ? `${style.fontSize}px` : `${this.emailData.root.data.fontSize}px`;
        const fontWeight = style.fontWeight || 'bold';
        const textColor = props.buttonTextColor || '#FFFFFF';
        const buttonBackgroundColor = props.buttonBackgroundColor || '#999999';
        const borderRadius = props.buttonStyle === 'pill' ? '64px' : '4px';
        const display = props.fullWidth ? 'block' : 'inline-block';
        const fontFamily = fontFamilyMapping[style?.fontFamily] || fontFamilyMapping.DEFAULT;
        const size = props.size || 'medium';
        let padding;
        
        switch (size) {
          case 'x-small':
            padding = '4px 8px';
            break;
          case 'small':
            padding = '8px 12px';
            break;
          case 'large':
            padding = '16px 32px';
            break;
          default:
            padding = '12px 20px';
        }
  
        return {
          color: textColor,
          fontSize: fontSize,
          fontWeight: fontWeight,
          backgroundColor: buttonBackgroundColor,
          borderRadius: borderRadius,
          display: display,
          padding: padding,
          fontFamily: fontFamily,
          textDecoration: 'none',
        };
      },
    },
  };
  </script>
  
  <style>
  </style>
  


  